module.exports = __webpack_public_path__ + "static/media/security.7b5dfe95.png";